import React from 'react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

const StatCard = ({ title, value, icon: Icon, trend, className }) => {
  return (
    <Card className={cn(
      "relative overflow-hidden border-border/40 bg-card/50 backdrop-blur-sm hover:shadow-lg transition-all duration-300",
      className
    )}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-3xl font-bold mt-2 text-foreground">{value}</p>
            {trend && (
              <p className={cn(
                "text-xs mt-2",
                trend > 0 ? "text-emerald-500" : "text-red-500"
              )}>
                {trend > 0 ? '+' : ''}{trend}% from last week
              </p>
            )}
          </div>
          {Icon && (
            <div className="rounded-xl bg-primary/10 p-3">
              <Icon className="h-6 w-6 text-primary" />
            </div>
          )}
        </div>
      </CardContent>
      {/* Decorative gradient */}
      <div className="absolute -right-4 -top-4 h-24 w-24 rounded-full bg-primary/5 blur-2xl" />
    </Card>
  );
};

export default StatCard;
